import { useEffect, useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Services from "@/components/Services";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import BookingDialog from "@/components/BookingDialog";

export default function Landing() {
  const [services, setServices] = useState([]);
  const [open, setOpen] = useState(false);
  const [initialServiceId, setInitialServiceId] = useState(null);
  const [initialAddon, setInitialAddon] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/services");
        setServices(data);
      } catch (e) {
        toast.error(formatApiError(e, "Could not load services"));
      }
    })();
  }, []);

  const openBooking = (serviceId = null, addon = false) => {
    setInitialServiceId(serviceId);
    setInitialAddon(addon);
    setOpen(true);
  };

  return (
    <div data-testid="landing-page">
      <Navbar onBookNow={() => openBooking()} />
      <main className="pt-16">
        <Hero onBookNow={() => openBooking()} />
        <About />
        <Services services={services} onBook={openBooking} />
        <Contact onBookNow={() => openBooking()} />
      </main>
      <Footer />
      <BookingDialog
        open={open}
        onOpenChange={setOpen}
        services={services}
        initialServiceId={initialServiceId}
        initialAddon={initialAddon}
      />
    </div>
  );
}
